const SENT_MESSAGES_KEY = 'sent_messages';
const DARK_MODE_KEY = 'dark_mode';
const ONBOARDING_SHOWN_KEY = 'onboarding_shown';
const ONBOARDING_INDEX = 'onboarding_index';
const BLOCK_LIST_KEY = 'block_list';
const BLOCKED_BY_LIST_KEY = 'blocked_by_list';
const MILLIS_PER_MIN = 1000 * 60;
var darkModeEnabled = readDarkModePreference();
export var inMemoryBlockList = getBlockList();
let inMemoryBlockedByList = getBlockedByList();
enableDarkMode(darkModeEnabled);

export function getMessagesCache() {
  let storageItem = localStorage.getItem(SENT_MESSAGES_KEY);
  let sentMessages;
  if (storageItem === null) {
    sentMessages = new Map();
  } else {
    sentMessages = new Map(JSON.parse(storageItem));
  }

  return validateMessageCache(sentMessages);
}

function validateMessageCache(sentMessages) {
  for (const [key, value] of sentMessages.entries()) {
    if (Date.now() - value > 5 * MILLIS_PER_MIN) {
      sentMessages.delete(key);
    }
  }

  localStorage.setItem(SENT_MESSAGES_KEY, JSON.stringify([...sentMessages]));
  return sentMessages;
}

export function cacheMessage(newMessage) {
  let sentMessages = getMessagesCache();
  sentMessages.set(newMessage, Date.now());
  localStorage.setItem(SENT_MESSAGES_KEY, JSON.stringify([...sentMessages]));
}

/* Dark Mode */

function saveDarkModePreference(darkModeEnabled) {
  localStorage.setItem(DARK_MODE_KEY, JSON.stringify(darkModeEnabled));
}

export function readDarkModePreference() {
  var darkModeEnabled = localStorage.getItem(DARK_MODE_KEY);
  if (
    darkModeEnabled === 'undefined' ||
    darkModeEnabled === null ||
    darkModeEnabled == null
  ) {
    darkModeEnabled = true;
    saveDarkModePreference(darkModeEnabled);
  } else {
    darkModeEnabled = JSON.parse(darkModeEnabled);
  }
  return darkModeEnabled;
}

export function hasSeenOnboarding() {
  var hasSeenOnboarding = localStorage.getItem(ONBOARDING_SHOWN_KEY);
  if (hasSeenOnboarding == null) {
    return false;
  }

  return hasSeenOnboarding;
}

export function saveHasSeenOnboarding() {
  localStorage.setItem(ONBOARDING_SHOWN_KEY, true);
}

export function toggleDarkMode() {
  darkModeEnabled = !darkModeEnabled;
  saveDarkModePreference(darkModeEnabled);
  enableDarkMode();
  return darkModeEnabled;
}

export function setDarkMode(isDarkMode) {
  if (isDarkMode) {
    darkModeEnabled = true;
  } else {
    darkModeEnabled = false;
  }
  saveDarkModePreference(darkModeEnabled);
  enableDarkMode();
}

export function getOnboardingIndex() {
  var onboardingIndex = localStorage.getItem(ONBOARDING_INDEX);
  if (onboardingIndex == null) {
    return 0;
  }

  return parseInt(onboardingIndex, 10);
}

export function setOnboardingIndex(index) {
  localStorage.setItem(ONBOARDING_INDEX, index);
}

export function resetOnboarding() {
  localStorage.setItem(ONBOARDING_INDEX, 0);
}

function enableDarkMode() {
  if (darkModeEnabled) {
    // Set screen to black
    document.documentElement.style.setProperty('--clr-prim', '#1e1e1e');
    document.documentElement.style.setProperty('--clr-sec', '#e1e1e1');
    document.documentElement.style.setProperty('--clr-tert', '#1e1e1e');
    document.documentElement.style.setProperty('--clr-shadow', '#000');
    document.documentElement.style.setProperty('--clr-bg', '#121212');
    document.documentElement.style.setProperty('--clr-invert-bg', '#fdfdfd');
    document.documentElement.style.setProperty('--clr-cached', '#999999');
    //DARK_MODE_BUTTON.textContent = "Light Mode";
  } else {
    // Set screen to white
    document.documentElement.style.setProperty('--clr-prim', '#fff');
    document.documentElement.style.setProperty('--clr-sec', '#000');
    document.documentElement.style.setProperty('--clr-tert', '#ebedef');
    document.documentElement.style.setProperty('--clr-shadow', '#dedede');
    document.documentElement.style.setProperty('--clr-bg', '#fdfdfd');
    document.documentElement.style.setProperty('--clr-invert-bg', '#121212');
    document.documentElement.style.setProperty('--clr-cached', '#777777');
    //DARK_MODE_BUTTON.textContent = "Dark Mode";
  }
}

export function getBlockList() {
  let storageItem = localStorage.getItem(BLOCK_LIST_KEY);
  let blockList;
  if (storageItem === null) {
    blockList = new Set();
  } else {
    blockList = new Set(JSON.parse(storageItem));
  }

  return blockList;
}

export function addToBlockList(newBlock, nickname = null, messageText = null) {
  let blockList = getBlockList();

  // If it's just a userId string (legacy), convert to object
  if (typeof newBlock === 'string') {
    newBlock = {
      userId: newBlock,
      nickname: nickname,
      messageText: messageText,
      blockedAt: Date.now(),
    };
  }

  // Remove any existing entry for this userId first
  const existingEntries = Array.from(blockList);
  const filteredEntries = existingEntries.filter((entry) => {
    if (typeof entry === 'string') {
      return entry !== newBlock.userId;
    }
    return entry.userId !== newBlock.userId;
  });

  blockList = new Set([...filteredEntries, newBlock]);
  inMemoryBlockList = blockList;
  localStorage.setItem(BLOCK_LIST_KEY, JSON.stringify([...blockList]));
}

export function removeFromBlockList(userId) {
  let blockList = getBlockList();
  const existingEntries = Array.from(blockList);

  // Filter out the entry with matching userId (handle both string and object formats)
  const filteredEntries = existingEntries.filter((entry) => {
    if (typeof entry === 'string') {
      return entry !== userId;
    }
    return entry.userId !== userId;
  });

  blockList = new Set(filteredEntries);
  inMemoryBlockList = blockList;
  localStorage.setItem(BLOCK_LIST_KEY, JSON.stringify([...blockList]));
}

export function isUserBlocked(userId) {
  const blockList = getBlockList();
  const entries = Array.from(blockList);

  return entries.some((entry) => {
    if (typeof entry === 'string') {
      return entry === userId;
    }
    if (!entry || typeof entry !== 'object') {
      return false;
    }
    return entry.userId === userId;
  });
}

/* Blocked By List - tracks users who have blocked the current user */

export function getBlockedByList() {
  let storageItem = localStorage.getItem(BLOCKED_BY_LIST_KEY);
  if (storageItem === null) {
    return new Set();
  }
  return new Set(JSON.parse(storageItem));
}

export function setBlockedByList(userIds) {
  const blockedBySet = new Set(userIds);
  inMemoryBlockedByList = blockedBySet;
  localStorage.setItem(BLOCKED_BY_LIST_KEY, JSON.stringify([...blockedBySet]));
}

export function addToBlockedByList(userId) {
  const blockedByList = getBlockedByList();
  blockedByList.add(userId);
  inMemoryBlockedByList = blockedByList;
  localStorage.setItem(BLOCKED_BY_LIST_KEY, JSON.stringify([...blockedByList]));
}

export function removeFromBlockedByList(userId) {
  const blockedByList = getBlockedByList();
  blockedByList.delete(userId);
  inMemoryBlockedByList = blockedByList;
  localStorage.setItem(BLOCKED_BY_LIST_KEY, JSON.stringify([...blockedByList]));
}

export function isBlockedBy(userId) {
  return inMemoryBlockedByList.has(userId);
}
